import { render, staticRenderFns } from "./RareDataFormatSwitch.vue?vue&type=template&id=274574ba&scoped=true"
import script from "./RareDataFormatSwitch.vue?vue&type=script&lang=js"
export * from "./RareDataFormatSwitch.vue?vue&type=script&lang=js"
import style0 from "./RareDataFormatSwitch.vue?vue&type=style&index=0&id=274574ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274574ba",
  null
  
)

export default component.exports